import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';

export const SubscribeBindQrcodeModalContent = memo(
  ({ qrcodeImageUrl }: { qrcodeImageUrl: string }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    const [error, setError] = useState<Error>();
    __DEV__ && console.log('qrcode url: ', qrcodeImageUrl);
    return (
      <View>
        <View
          css={`
            border-width: 1px;
            border-color: ${theme.task.subscribeBindModal.qrcode.borderColor};
            align-self: center;
            padding: ${rpx(40)}px;
          `}
        >
          <Image
            source={{ uri: qrcodeImageUrl }}
            resizeMode="cover"
            onError={e => setError(e.nativeEvent.error)}
            css={`
              width: ${rpx(320)}px;
              height: ${rpx(320)}px;
            `}
          />
          {error ? (
            <Center
              css={`
                padding: ${rpx(40)}px;
              `}
              style={StyleSheet.absoluteFill}
            >
              <Typography.Label
                size={rpx(30)}
                color={theme.alert.errorTextColor}
                css={`
                  text-align: center;
                `}
              >
                {`获取二维码失败`}
              </Typography.Label>
            </Center>
          ) : null}
        </View>
        <Typography.Label
          regular
          size={rpx(30)}
          lineHeight={rpx(48)}
          color={theme.alert.messageTextColor}
          css={`
            text-align: center;
            margin-top: ${rpx(32)}px;
          `}
        >
          扫码关注获取实时车辆服务动态
        </Typography.Label>
      </View>
    );
  },
);
